/* ============================================================
   api.js — thin fetch wrapper around the Functions API.
   The session lives in an HttpOnly cookie, so every call is
   same-origin with credentials included.
   ============================================================ */

const BASE = '/api';

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

async function request(method, path, payload) {
  let res;
  try {
    res = await fetch(BASE + path, {
      method,
      credentials: 'same-origin',
      headers: payload === undefined ? {} : { 'Content-Type': 'application/json' },
      body: payload === undefined ? undefined : JSON.stringify(payload),
    });
  } catch {
    throw new ApiError('Ingen kontakt med servern. Kolla nätverket och försök igen.', 0);
  }

  const text = await res.text();
  const data = text ? safeParse(text) : null;
  if (!res.ok) throw new ApiError((data && data.error) || `Serverfel (${res.status}).`, res.status);
  return data;
}

function safeParse(text) {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export const api = {
  get: path => request('GET', path),
  post: (path, payload = {}) => request('POST', path, payload),
  patch: (path, payload = {}) => request('PATCH', path, payload),
  put: (path, payload = {}) => request('PUT', path, payload),
  del: path => request('DELETE', path),
};
